export default __webpack_public_path__ + "static/media/quiz-ending-sad.0bc6c5e6.svg";